<template>
  <el-dialog title="批量发送晚点短信" :visible.sync="visible" width="1100px" :close-on-click-modal="false"
    @closed="reset">
    <el-form :inline="true" size="small" :model="queryForm">
      <el-form-item label="日期">
        <el-date-picker v-model="queryForm.date" type="date" value-format="yyyy-MM-dd" placeholder="日期"
          style="width: 150px" />
      </el-form-item>
      <el-form-item label="路线">
        <el-select v-model="queryForm.pathId" clearable filterable placeholder="全部路线" style="width: 180px">
          <el-option v-for="item in pathOpts" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="订票时间">
        <el-time-select v-model="queryForm.startTime" :picker-options="timeOpts" placeholder="开始时间"
          style="width: 120px" />
        <span class="time-split">-</span>
        <el-time-select v-model="queryForm.endTime" :picker-options="timeOpts" placeholder="结束时间"
          style="width: 120px" />
      </el-form-item>
      <el-form-item label="订单状态">
        <el-select v-model="queryForm.orderStatusList" multiple collapse-tags placeholder="请选择" style="width: 220px">
          <el-option v-for="item in statusOpts" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="query">查询</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="list" max-height="360" stripe :row-class-name="rowClassName"
      @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="50" />
      <el-table-column prop="date" label="日期" width="110" />
      <el-table-column prop="showTime" label="时间" width="120" />
      <el-table-column prop="telephone" width="150" label="手机">
        <template slot-scope="scope">
          <tel-cell :order="scope.row" />
        </template>
      </el-table-column>
      <el-table-column prop="departure" label="起点" show-overflow-tooltip />
      <el-table-column prop="destination" label="终点" show-overflow-tooltip />
      <el-table-column prop="driverNo" label="司机编号" width="100" />
      <el-table-column prop="orderStatus" label="订单状态" width="120">
        <template slot-scope="scope">
          {{ scope.row.orderStatus | enumTransfer(statusOpts) }}
        </template>
      </el-table-column>
      <el-table-column label="发送记录" width="90">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.sent" type="info" size="mini">已发送</el-tag>
          <span v-else>未发送</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="summary">共 {{ list.length }} 单，已选 {{ selectedIds.length }} 单，已发送 {{ sentCount }} 单</div>

    <el-form label-width="80px" size="small" class="reason-form">
      <el-form-item label="晚点原因">
        <el-input v-model="reason" type="textarea" :rows="3" placeholder="请输入晚点原因" />
        <div class="reason-tags">
          <el-tag v-for="item in reasonOpts" :key="item" size="small" @click="reason = item">{{ item }}</el-tag>
        </div>
      </el-form-item>
    </el-form>

    <span slot="footer">
      <el-button size="small" @click="visible = false">取消</el-button>
      <el-button size="small" type="primary" @click="confirmSend">确认发送</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { queryDelaySmsOrders, batchSendDelaySms } from "@/api";
import { DateUtil } from "@/util";

const STATUS_OPTS = [
  { value: "ACTIVE", label: "等待分派司机" },
  { value: "PRE_DISPATCH", label: "预派单" },
  { value: "MATCHED", label: "已分配司机" }
];

export default {
  props: {
    pathOpts: {
      type: Array,
      default: () => []
    },
    pathId: {
      type: [Number, String],
      default: null
    }
  },
  computed: {
    sentCount() {
      return this.list.filter((item) => item.sent).length;
    }
  },
  data() {
    return {
      visible: false,
      list: [],
      selectedIds: [],
      reason: "",
      statusOpts: STATUS_OPTS,
      reasonOpts: ["道路拥堵", "交通管制", "车辆故障", "节假日交通拥堵"],
      timeOpts: {
        start: "00:00",
        step: "00:60",
        end: "23:00"
      },
      queryForm: this.createQueryForm()
    };
  },
  methods: {
    createQueryForm() {
      return {
        date: DateUtil.getDayStr(0),
        pathId: this.pathId || null,
        startTime: "",
        endTime: "",
        orderStatusList: STATUS_OPTS.map((item) => item.value)
      };
    },
    open() {
      this.queryForm = this.createQueryForm();
      this.list = [];
      this.selectedIds = [];
      this.reason = "";
      this.visible = true;
    },
    reset() {
      this.list = [];
      this.selectedIds = [];
      this.reason = "";
    },
    query() {
      if (!this.queryForm.date) {
        this.$message.error("请选择日期");
        return;
      }
      const param = {
        date: this.queryForm.date,
        pathId: this.queryForm.pathId || undefined,
        orderStatusList: this.queryForm.orderStatusList
      };
      if (this.queryForm.startTime) {
        param.startTime = `${this.queryForm.startTime}:00`;
      }
      if (this.queryForm.endTime) {
        param.endTime = `${this.queryForm.endTime}:00`;
      }
      queryDelaySmsOrders(param).then((res) => {
        this.list = res.data || [];
        this.selectedIds = [];
      });
    },
    handleSelectionChange(rows) {
      this.selectedIds = rows.map((item) => item.id);
    },
    rowClassName({ row }) {
      return row.sent ? "sent-row" : "";
    },
    confirmSend() {
      if (!this.selectedIds.length) {
        this.$message.error("请选择订单");
        return;
      }
      const reason = (this.reason || "").trim();
      if (!reason) {
        this.$message.error("请输入晚点原因");
        return;
      }
      batchSendDelaySms({
        orderIds: this.selectedIds,
        reason
      }).then(() => {
        this.$message.success("短信发送成功");
        this.visible = false;
      });
    }
  }
};
</script>

<style lang="less" scoped>
.time-split {
  margin: 0 6px;
}

.summary {
  margin-top: 8px;
  color: #f56c6c;
}

/deep/ .sent-row {
  color: #909399;
}

.reason-form {
  margin-top: 12px;
}

.reason-tags {
  margin-top: 8px;

  .el-tag {
    cursor: pointer;
    margin-right: 6px;
  }
}
</style>
